

import http from "@/utils/http";


export const DmsDeviceApi = {

    queryDmsDeviceList(data) {
        return http.post(`/server/dmsDevice/queryDmsDeviceList`,data)
    },
	countDevice(){
		return http.get(`/server/dmsDevice/countDevice`, );
	},

}